/* eslint-disable array-callback-return */
/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { Component } from 'react';
import { Select, Icon, Spin, Empty } from 'antd';
import networkList from '../../../constants/networkList';
import postService from '../../../services/httpService';
import { OPTION_IDS } from '../../../constants/app-constants';
class Select2multiple extends Component {
    constructor(props) {
        super(props);
        this.state = {
            date: new Date(),
            select2options: [],
            loading: false,
            selectdata: {},
            fetching: true
        };
    }
    componentDidMount() {
        this.setState((state) => ({ 'selectdata': this.props.selectdata,select2options: [], loading: true}),()=>{
           
            // this.selectFetchCall();
        });
        console.log(this.props.selectdata);
        
    }

    componentDidUpdate(prevProps, pervState) {
        if (prevProps.selectdata.value != this.props.selectdata.value) {
            this.setState((state) => ({ 'selectdata': this.props.selectdata }));
        }
    }

    handleChange(value) {
        console.log(`selected ${value}`);
    }

    onChange(value) {


        let { selectdata } = this.state;
        selectdata['value'] = value;


        // this.selectFetchCall();
        let text = null;

        this
            .state
            .select2options
            .map((data, key) => {
                if (data['id'] === value) {
                    text = data['name'];
                }
            });


        selectdata['text'] = text;
        this.setState((state) => ({ 'selectdata': selectdata }));
        if (this.props.selectdata.name === 'service') {
            this
                .state
                .select2options
                .map((data, key) => {
                    if (data.id === value) {
                        this
                            .props
                            .onselectChanges({
                                id: this.props.selectdata.name,
                                name: this.props.selectdata.name,
                                value: value,
                                parrentMode: this.props.selectdata.parrentMode,
                                parrentName: this.props.selectdata.parrentName,
                                serviceTime: data.service_time,
                                text: text
                            });
                    }
                })

        } else if (this.props.selectdata.name === 'room_opted') {
            this
                .state
                .select2options
                .map((data, key) => {
                    if (data.id === value) {
                        this
                            .props
                            .onselectChanges({
                                id: this.props.selectdata.name,
                                name: this.props.selectdata.name,
                                value: value,
                                parrentMode: this.props.selectdata.parrentMode,
                                parrentName: this.props.selectdata.parrentName,
                                amount: data.amount,
                                text: text
                            });
                    }
                })

        }

        else if (this.props.selectdata.name === 'package_name') {
            this
                .state
                .select2options
                .map((data, key) => {
                    if (data.id === value) {
                        this
                            .props
                            .onselectChanges({
                                id: this.props.selectdata.name,
                                name: this.props.selectdata.name,
                                value: value,
                                parrentMode: this.props.selectdata.parrentMode,
                                parrentName: this.props.selectdata.parrentName,
                                length_of_stay: data.length_of_stay,
                                text: text
                            });
                    }
                })

        }

        else if (this.props.selectdata.name === 'patient_list') {
            this
                .state
                .select2options
                .map((data, key) => {
                    if (data.id === value) {
                        this
                            .props
                            .onselectChanges({
                                id: this.props.selectdata.name,
                                name: this.props.selectdata.name,
                                value: value,
                                parrentMode: this.props.selectdata.parrentMode,
                                parrentName: this.props.selectdata.parrentName,
                                serviceTime: data.service_time,
                                text: text
                            });
                    }
                })
        } else if (this.props.selectdata.name === 'doctorid') {
            this
                .state
                .select2options
                .map((data, key) => {
                    if (data.id === value) {
                        this
                            .props
                            .onselectChanges({
                                id: this.props.selectdata.name,
                                name: this.props.selectdata.name,
                                value: value,
                                parrentMode: this.props.selectdata.parrentMode,
                                parrentName: this.props.selectdata.parrentName,
                                speciality: data.speciality,
                                speciality_id: data.speciality,
                                text: text
                            });
                    }
                })
        }
        
        else {
            this
                .props
                .onselectChanges({
                    id: this.props.selectdata.name,
                    text: text,
                    name: this.props.selectdata.name,
                    value: value,
                    parrentMode: this.props.selectdata.parrentMode,
                    parrentName: this.props.selectdata.parrentName
                });
        }

    }

    onBlur() {
        console.log('blur');
        console.log(this.props);
        // this.selectFetchCall(); this.selectFetchCall();
    }

    onFocus() {
        console.log('focus');
         this.setState({ select2options: [], loading: true });
        // //console.log(this.props);
         this.selectFetchCall();
    }

    onSearch(val) {
        console.log('search:', val);
    }

    selectFetchCall() {
        this.setState({ fetching: true });
        const {

            getProcedures,
            getDoctorsforDropdown,
            getDepartmentsFromPatients,
            getNurseStationDropdownFromPatients,
            getWardsDropdownFromPatients,
            getTrackBillStatuses,
            getDepartmentsFromDoctors,
            getMasterServicesForNurse,
            getMasterDrugsForNurse,
            getMasterProceduresForNurse,
            getCounsellorTypes,
            getMasterTariffs,

        } = networkList;



        if (this.props.selectdata.name === 'surgery_procedure_name' || this.props.selectdata.name === 'additional_procedure' || this.props.selectdata.name === 'surgery') {
            postService(getProcedures, 'GET', 'null').then(res => {
                if (res) {
                    this.setState((state) => ({ select2options: res.data, loading: false, fetching: false }));
                } else {
                    this.setState({ fetching: false });
                }
            });
        }
        if (this.props.selectdata.name === 'doctorid') {
            postService(getDoctorsforDropdown, 'GET', 'null').then(res => {
                if (res) {
                    this.setState((state) => ({ select2options: res.data, loading: false, fetching: false }));
                } else {
                    this.setState({ fetching: false });
                }
            });
        }  
        if (this.props.selectdata.name === 'departmentbyunit') {
            let user_data = ''
            if (localStorage.getItem('user_data') !== null && localStorage.getItem('user_data') !== undefined && localStorage.getItem('user_data') !== '') {
             user_data = JSON.parse(localStorage.getItem('user_data'))
            }
            postService(getDepartmentsFromDoctors, 'POST', {
                "data": { "unit_id": user_data['unitid'] ? user_data['unitid'] : ''}                   
            }).then(res => {
                if (res) {
                    this.setState((state) => ({ select2options: res.data, loading: false, fetching: false }));
                } else {
                    this.setState({ fetching: false });
                }
            });
        }
        if (this.props.selectdata.name === 'pendingDocs_departmentbyunit') {
            let user_data = ''
            if (localStorage.getItem('user_data') !== null && localStorage.getItem('user_data') !== undefined && localStorage.getItem('user_data') !== '') {
             user_data = JSON.parse(localStorage.getItem('user_data'))
            }
            postService(getDoctorsforDropdown, 'GET', 'null').then(res => {
                if (res) {
                    const result = [];
                    const map = new Map();

                    if (res['data'].length !== 0) {
                        //  remove duplicate obj
                        for (const item of res['data']) {
                            if (!map.has(item.departmentname)) {
                                map.set(item.departmentname, true);    // set any value to Map
                                result.push({
                                    id: item.departmentname,
                                    name: item.departmentname
                                });
                            }
                        }
                    }
                    this.setState((state) => ({ select2options: result, loading: false, fetching: false }));
                } else {
                    this.setState({ fetching: false });
                }
            });
        }   
        if (this.props.selectdata.name === 'payer_type') {
            var data = [
                {
                    'id': 'GENERAL',
                    'name': 'General'
                }, {
                    'id': 'INSURANCE',
                    'name': 'Insurance'
                },{
                    'id': 'CORPORATE',
                    'name': 'Corporate'
                },
                {
                    'id' : "ADT1",
                    'name': "Cash - Insurance conversion not yet done"
                },
                {
                    'id' : "icpending",
                    'name': "Insurance conversion pending"
                }
            ]
            this.setState((state) => ({ select2options: data, loading: false, fetching: false }));
        }
        if (this.props.selectdata.name === 'payment_type') {
            var data = [
                {
                    'id': 1,
                    'name': 'Cash'
                }, {
                    'id': 2,
                    'name': 'Insurance'
                }
            ]
            this.setState((state) => ({ select2options: data, loading: false, fetching: false }));
        }

        if (this.props.selectdata.name === 'due_payer_type') {
            var data = [
                {
                    'id': 'GENERAL',
                    'name': 'General'
                }, {
                    'id': 'INSURANCE',
                    'name': 'Insurance'
                },{
                    'id': 'CORPORATE',
                    'name': 'Corporate'
                },{
                    'id' : "ADT1",
                    'name': "Cash - Insurance conversion not yet done"
                }
            ]
            this.setState((state) => ({ select2options: data, loading: false, fetching: false }));
        }

        if (this.props.selectdata.name === 'bill_value') {
            var data = [{
                "id":"1",
                "name":"< 1 L"
             },{
                "id":"2",
                "name":"1 to 3 L"
             },{
                "id":"3",
                "name":"> 3 L"
             }]
            this.setState((state) => ({ select2options: data, loading: false, fetching: false }));
        }

        if (this.props.selectdata.name === 'due_amount') {
            var data = [{
                "id":"1",
                "name":"< 1 L"
             },{
                "id":"2",
                "name":"1 to 3 L"
             },{
                "id":"3",
                "name":"> 3 L"
             }]
            this.setState((state) => ({ select2options: data, loading: false, fetching: false }));
        }

        if (this.props.selectdata.name === 'nursestationbyunit') {
            let user_data = ''
           if (localStorage.getItem('user_data') !== null && localStorage.getItem('user_data') !== undefined && localStorage.getItem('user_data') !== '') {
            user_data = JSON.parse(localStorage.getItem('user_data'))
           }
            postService(getNurseStationDropdownFromPatients, 'POST', {
                "data": { "unit_id": user_data['unitid'] ? user_data['unitid'] : ''}                   
            }).then(res => {
    
                if (res) {
                    this.setState((state) => ({ select2options: res.data, loading: false, fetching: false }));
                } else {
                    this.setState({ select2options: [], fetching: false });
                }
            });
        }

        if (this.props.selectdata.name === 'trackbill_statuses') {
            let user_data = ''
           if (localStorage.getItem('user_data') !== null && localStorage.getItem('user_data') !== undefined && localStorage.getItem('user_data') !== '') {
            user_data = JSON.parse(localStorage.getItem('user_data'))
           }
            postService(getTrackBillStatuses, 'POST', {
                "data": { "unit_id": user_data['unitid'] ? user_data['unitid'] : ''}                   
            }).then(res => {
    
                if (res) {
                    this.setState((state) => ({ select2options: res.data, loading: false, fetching: false }));
                } else {
                    this.setState({ select2options: [], fetching: false });
                }
            });
        }


        if (this.props.selectdata.name === 'ward_name') {
            let user_data = ''
           if (localStorage.getItem('user_data') !== null && localStorage.getItem('user_data') !== undefined && localStorage.getItem('user_data') !== '') {
            user_data = JSON.parse(localStorage.getItem('user_data'))
           }
            postService(getWardsDropdownFromPatients, 'POST', {
                "data": { "unit_id": user_data['unitid'] ? user_data['unitid'] : ''}                   
            }).then(res => {
    
                if (res) {
                    this.setState((state) => ({ select2options: res.data, loading: false, fetching: false }));
                } else {
                    this.setState({ select2options: [], fetching: false });
                }
            });
        }

        if (this.props.selectdata.name === 'ward_type') {
            var data = [{
                "id":"COVID",
                "name": "COVID"
                },
                {
                "id":"NON-COVID",
                "name": "NON COVID"
                }]
            this.setState((state) => ({ select2options: data, loading: false, fetching: false }));
        }
        if (this.props.selectdata.name === 'due_percent') {
            var data =[{ "id": 1, "name": "Less than 20%"},
            { "id": 2, "name": "20-40%" },
            { "id": 3, "name": "40-60%" },
            { "id": 4, "name": "60-80%" },
            { "id": 5, "name": "More than 80%"}]
            this.setState((state) => ({ select2options: data, loading: false, fetching: false }));
        }

        if (this.props.selectdata.name === 'work_list_type') {
            var data = [{
                "id":"trackbill",
                "name": "TRACK BILL"
                },
                {
                "id":"duebill",
                "name": "DUE BILL"
                }]
            this.setState((state) => ({ select2options: data, loading: false, fetching: false }));
        }

        if (this.props.selectdata.name === 'payer_type') {
            var data = [
                {
                    'id': '',
                    'name': 'All'
                },
                {
                    'id': 'Cash',
                    'name': 'Cash'
                }, {
                    'id': 'Insurance',
                    'name': 'Insurance'
                }
                , {
                    'id': 'Corporate',
                    'name': 'Corporate'
                }
            ]
            this.setState((state) => ({ select2options: data, loading: false, fetching: false }));
        }

        if (this.props.selectdata.name === 'exclude_departments') {     
            let smsUnit_id = this.props.smsUnit_id       
            postService(getDepartmentsFromDoctors, 'POST', {
                "data": { "unit_id": smsUnit_id ? smsUnit_id : null}                   
            }).then(res => {
                if (res) {
                    this.setState((state) => ({ select2options: res.data, loading: false, fetching: false }));
                } else {
                    this.setState({ fetching: false });
                }
            });
        } 
        if (this.props.selectdata.name === 'include_departments') {     
            let smsUnit_id = this.props.smsUnit_id       
            postService(getDepartmentsFromDoctors, 'POST', {
                "data": { "unit_id": smsUnit_id ? smsUnit_id : null}                   
            }).then(res => {
                if (res) {
                    this.setState((state) => ({ select2options: res.data, loading: false, fetching: false }));
                } else {
                    this.setState({ fetching: false });
                }
            });
        } 
        if (this.props.selectdata.name === 'variance') {
            var data = [
            //     {
            //     "id": 1,
            //     "name": "Negative >10"
            // },
             {
                "id": 2,
                "name": "Negative 10-20"
            }, {
                "id": 3,
                "name": "Negative 20-40"
            }, {
                "id": 4,
                "name": "Negative 40-60"
            }, {
                "id": 5,
                "name": "Negative <60"
            }, 
            // {
            //     "id": 6,
            //     "name": "Positive <10"
            // },
             {
                "id": 7,
                "name": "Positive 10-20"
            }, {
                "id": 8,
                "name": "Positive 20-40"
            }, {
                "id": 9,
                "name": "Positive 40-60"
            }, {
                "id": 10,
                "name": "Positive >60"
            }];
            this.setState((state) => ({ select2options: data, loading: false, fetching: false }));
        }
        if (this.props.selectdata.name === 'pre_auth_submitted') {
            var data = [
                {
                    'id': 'YES',
                    'name': 'YES'
                }, {
                    'id': 'NO',
                    'name': 'NO'
                }
               
            ]
            this.setState((state) => ({ select2options: data, loading: false, fetching: false }));
        }
        if (this.props.selectdata.name === 'assignedFrom') {
            var data = [
                {
                    'id': 'RL_weyI',
                    'name': 'Assigned From GRE'
                }, {
                    'id': 'RL_8GzM',
                    'name': 'Assigned From DMO'
                }
               
            ]
            this.setState((state) => ({ select2options: data, loading: false, fetching: false }));
        }
        if (this.props.selectdata.name === 'counsellor_submitted') {
            var data = [
                {
                    'id': '1',
                    'name': 'YES'
                }, {
                    'id': '0',
                    'name': 'NO'
                }
               
            ]
            this.setState((state) => ({ select2options: data, loading: false, fetching: false }));
        }
        if (this.props.selectdata.name === 'insurance_status') {
            var data = [{
                "id": "1",
                "name": "Initial Draft"
            }, {
                "id": "30",
                "name": "Preauthorization - Need More Information"
            }, {
                "id": "31",
                "name": "Preauthorization - Approved"
            }, {
                "id": "32",
                "name": "Preauthorization - Denied"
            }, {
                "id": "33",
                "name": "Preauthorization - Enhanced"
            }, {
                "id": "34",
                "name": "Preauthorization - Cancelled"
            }, {
                "id": "35",
                "name": "Preauthorization - Enhancement – Denied"
            }, {
                "id": "3",
                "name": "Pre Discharge - Approved"
            }, {
                "id": "4",
                "name": "Pre Discharge - Need More Information"
            }, {
                "id": "5",
                "name": "Pre Discharge - Rejected"
            }, {
                "id": "8",
                "name": "Pre Discharge – Cancelled"
            }, {
                "id": "43",
                "name": "Pre Discharge – Under Process"
            }, {
                "id": "54",
                "name": "Enhance - Query Replied - Draft"
            }, {
                "id": "52",
                "name": "Enhance - Discharge - Draft"
            }, {
                "id": "53",
                "name": "Enhance Reconsider - Draft"
            }]
            this.setState((state) => ({ select2options: data, loading: false, fetching: false }));
        }
        if (this.props.selectdata.name === 'fc_payer_type') {
            var data = [
                {
                    'id': 1,
                    'name': 'Cash'
                }, {
                    'id': 2,
                    'name': 'Insurance'
                },{
                    'id': 3,
                    'name': 'Corporate'
                }
            ]
            this.setState((state) => ({ select2options: data, loading: false, fetching: false }));
        }
        if (this.props.selectdata.name === 'multiple_unit') {     
            postService('getUnitsall', 'GET', 'null').then(res => {
                if (res) {
                    this.setState((state) => ({ select2options: res.data, loading: false, fetching: false }));
                } else {
                    this.setState({ fetching: false });
                }
            });
        } 
        if (this.props.selectdata.name === 'tariff') {
            let user_data = ''
           if (localStorage.getItem('user_data') !== null && localStorage.getItem('user_data') !== undefined && localStorage.getItem('user_data') !== '') {
            user_data = JSON.parse(localStorage.getItem('user_data'))
           }
            postService(getMasterTariffs, 'POST', {
                "data": { "page_no":"1","unit_id": user_data['unitid'] ? user_data['unitid'] : '' }    
            }).then(res => {

                if (res) {
                    this.setState((state) => ({ select2options: res.data, loading: false, fetching: false }));
                } else {
                    this.setState({ fetching: false });
                }
            });  
        }
    }

    getQueuevalue(name) {
        let { Queuedata } = this.props;
        let value = null;
        Queuedata.filter(data => {
            if (data['name'] === name && data['valid']) {

                value = data['value'];
            }
        })
        return value;
    }
    getFormvalue(name) {
        let { formData } = this.props;
        let value = null;
        formData.filter(data => {
            if (data['name'] === name && data['valid']) {

                value = data['value'];
            }
        })
        return value;
    }

    render() {
        const { fetching } = this.state;
        // console.clear();
        let mode = 'multiple';
        let maxTagCount = null
        let defvalue = null;
        let valueText = this.state.selectdata.text ? this.state.selectdata.text : null;
        console.log(this.state.selectdata.text);
        const Option = Select.Option;
        const children = [];
        if (this.state.select2options.length !== 0) {
            this
                .state
                .select2options
                .map((data, key) => {
                    if (data.id !== null) {
                        children.push(
                            <Option key={key} value={data.id}>{data.name
                                ? data.name
                                : data.value}</Option>
                        );
                    }

                });
        }
        if (this.props.selectdata.name === 'additional_procedure' || this.props.selectdata.name === 'doctorid' || this.props.selectdata.name === 'departmentbyunit' || this.props.selectdata.name === 'trackbill_statuses'|| this.props.selectdata.name === 'ward_name' || this.props.selectdata.name === 'payer_type'|| this.props.selectdata.name === 'bill_value' || this.props.selectdata.name === 'nursestationbyunit' || this.props.selectdata.name === 'due_payer_type' || this.props.selectdata.name === 'due_amount' || this.props.selectdata.name === 'due_percent' || this.props.selectdata.name === 'work_list_type' || this.props.selectdata.name === 'pendingDocs_departmentbyunit' || this.props.selectdata.name==='payment_type' || this.props.selectdata.name==='multiple_unit') {
            mode = 'multiple';                       
            maxTagCount= 'responsive';
            defvalue = [];
            valueText = []
           
        }        
        return (

            <Select
                dropdownStyle={{ maxWidth: "30%" }}
                showSearch
                mode={mode}
                maxTagCount={maxTagCount}
                style={{
                    width: '100%'
                }}
                placeholder={this.state.selectdata.placeholder}
                defaultValue={defvalue}
                value={this.props.selectdata.value ? this.props.selectdata.value : []}
                optionFilterProp="children"
                onChange={this
                    .onChange
                    .bind(this)}
                onFocus={this
                    .onFocus
                    .bind(this)}
                onBlur={this
                    .onBlur
                    .bind(this)}
                notFoundContent={fetching ? <Spin size="small" /> : <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />}
                onSearch={this.onSearch}
                disabled={this.state.selectdata.disable}
                loading={false}
                // menuItemSelectedIcon={< Icon type="user" style={{ color: 'rgba(0,0,0,.25)' }} />}
                dropdownMatchSelectWidth={false}>
                {children}
            </Select>
        );
    }
}

export default Select2multiple;
